import { createApp } from 'vue';
import axios from 'axios';
import vueUIInitiator from '../../../modules/vue-ui-initiator';
import ReportTable from '../components/reports/ReportTable.vue';
import StarRate from '../../../vue-components/StarRate';

vueUIInitiator('js--star-rate', StarRate, 'star-rate');

document.addEventListener('DOMContentLoaded', () => {
    const reportParent = document.getElementById('it-mortgage-report');
    if (reportParent) {
        createApp({
            components: { ReportTable },
            data() {
                return {
                    url: '/api/public/content/mortgage/reports/weeklyreport/?type=itm', // prod and test
                    allCreditors: [],
                    allRegions: [],
                    allWeeks: [],
                    allColumns: [],
                    tableData: [],
                    showArr: [],
                    activeTab: 'creditors',
                    creditorName: 'Выберите кредитора',
                    regionName: 'Выберите регион',
                    columnName: 'Заключено кредитов, шт.',
                    columnId: 3,
                    weekName: '',
                    openSelect: '',
                    showContent: true,
                    weekBefore: '',
                    searchCreditor: '',
                    searchRegion: '',
                    searchArrCreditors: [],
                    searchArrRegions: [],
                    highlightCreditor: false,
                    highlightRegion: false,
                    highlightWeek: false,
                    highlightColumn: false,
                    highlightTab: false,
                    isLoad: false,
                    isFirstStart: true
                };
            },
            computed: {
                allCreditorsUrl() {
                    return this.url
                },
                allRegionsUrl() {
                    return this.url
                },
                allWeeksUrl() {
                    return this.url
                },
                allColumnsUrl() {
                    return (this.activeTab === 'creditors')
                        ? this.url + `&reportType=creditor`
                        : this.url + `&reportType=region`
                },
                reportUrl () {
                    return (this.activeTab === 'creditors')
                        ? this.url + `&reportType=creditor&date=${this.weekName}`
                        : this.url + `&reportType=region&date=${this.weekName}`
                },
                showRegion() {
                    return this.regionName.length && (this.regionName !== 'Выберите регион')
                },
                showCreditor() {
                    return this.creditorName.length && (this.creditorName !== 'Выберите кредитора')
                },
                showWeek() {
                    return this.weekName.length && (this.weekName !== this.allWeeks[0])
                },
                showAccent () {
                    return !(this.showArr.length || this.showRegion || this.showCreditor || this.showWeek)
                },
                tabName() {
                    return this.activeTab === 'creditors' ? 'Статистика по кредиторам' : 'Статистика по регионам'
                },
                startOfTheWeek() {
                    const raw = this.weekName.split('.');
                    const ordered = `${raw[2]}-${raw[1]}-${raw[0]}`;
                    const date = new Date(ordered);
                    date.setDate(date.getDate() - 7);
                    return date.toLocaleString().slice(0, 10);
                }
            },
            watch: {
                active() {
                    this.getApiData(this.url);
                    this.getApiData(this.allColumnsUrl, 'allColumns');
                },
                searchRegion(val) {
                    if (val.length >= 2) {
                        this.handlerSearch('region')
                    } else {
                        this.searchArrRegions = []
                    }
                },
                searchCreditor(val) {
                    if (val.length >= 2) {
                        this.handlerSearch('creditor')
                    } else {
                        this.searchArrCreditors = []
                    }
                },
                openSelect(val) {
                    this.$nextTick(() => {
                        if (val === 'creditor') {
                            this.$refs.inpCreditor.focus();
                        }
                        if (val === 'region') {
                            this.$refs.inpRegion.focus();
                        }
                    })
                },
                allWeeks() {
                    this.weekName = this.allWeeks[0];
                    this.weekBefore = this.allWeeks[1];
                    this.getApiData(this.reportUrl, 'tableData');
                },
            },
            mounted() {
                this.$nextTick(() => {
                    this.getApiData(this.url);
                    this.getApiData(this.allColumnsUrl, 'allColumns');
                });
            },
            methods: {
                getApiData(url, data, param) {
                    if (!param) {
                        this.showContent = false;
                        this.isLoad = true;
                    }
                    axios.get(url)
                        .then(response => {
                            if (response.data.dates) {
                                this.allWeeks = response.data.dates;
                            }

                            if (response.data.creditors) {
                                this.allCreditors = response.data.creditors;
                            }

                            if (response.data.regions) {
                                this.allRegions = response.data.regions
                            }

                            if (response.data.header?.main) {
                                this.allColumns = response.data.header.main;
                            }

                            this.tableData = response.data;

                            this.showContent = true;
                            // прелоадер убираем, чистим поля поиска
                            if (data === 'tableData') {
                                this.searchCreditor = '';
                                this.searchRegion = '';
                                this.isLoad = false;
                                const excelLinks = document.querySelectorAll('.js-get-excel');
                                if (excelLinks.length > 0) {
                                    excelLinks.forEach(item => {
                                        item.setAttribute('href', url + '&format=xlsx');
                                    });
                                }
                            }
                        })
                        .catch(error => {
                            console.error(error)
                        })
                        .finally(() => {
                            this.$nextTick(() => {
                                if (this.isFirstStart) {
                                    setTimeout(() => {
                                        this.isFirstStart = false;
                                    }, 4000)
                                }
                                this.isLoad = false;
                            });
                        })
                },
                toggleShowArray(data) {
                    this.$refs.table.setCurActiveId(data);
                },
                handlerTab(tabName) {
                    if (this.activeTab !== tabName) {
                        this.resetFilter();
                        this.activeTab = tabName;
                        this.openSelect = '';
                        this.getApiData(this.reportUrl, 'tableData');
                    }
                },
                handlerFilter(item, data) {
                    this.handlerSelect('');
                    if (item !== this[data]) {
                        this.showArr = [];
                        if (data === 'creditorName') {
                            this.highlightCreditor = true;
                        }
                        if (data === 'regionName') {
                            this.highlightRegion = true;
                        }
                        if (data === 'weekName') {
                            this.highlightWeek = true;
                            this.weekBefore = this.findPrevWeekItem(item);
                        }
                        this[data] = item;
                        let url = this.reportUrl;
                        if (this.showCreditor) {
                            // тут проблемка со скобкой: при запросе к API со скобкой - отдает пустой массив,
                            // а в названиях кредиторов встречается (ПАО), поэтому немного костылей
                            const currentName = this.creditorName.replace('(ПАО)', '');
                            url += '&creditor=' + currentName;
                            if (this.activeTab === 'regions' && this.regionName === 'Все') {
                                for (let i = 0; i < this.allRegions.length; i += 1) {
                                    this.showArr.push(this.allRegions[i])
                                }
                            }
                            this.toggleShowArray(this.creditorName)
                        }
                        if (this.showRegion) {
                            url += '&region=' + this.regionName;
                            if (this.activeTab === 'creditors' && this.creditorName === 'Все') {
                                for (let i = 0; i < this.allCreditors.length; i += 1) {
                                    this.showArr.push(this.allCreditors[i])
                                }
                            } else {
                                this.toggleShowArray(this.regionName)
                            }
                        }
                        if (this.showWeek) {
                            url += '&date=' + this.weekName;
                            if (this.activeTab === 'creditors' && this.creditorName === 'Все') {
                                for (let i = 0; i < this.allCreditors.length; i += 1) {
                                    this.showArr.push(this.allCreditors[i])
                                }
                            } else {
                                this.toggleShowArray(this.regionName)
                            }
                        }
                        this.getApiData(url, 'tableData');
                    }
                },
                findPrevWeekItem(curItem) {
                    const curItemIdx = this.allWeeks.findIndex(item => item === curItem);

                    return this.allWeeks[curItemIdx + 1];
                },
                resetFilter() {
                    this.creditorName = 'Выберите кредитора';
                    this.regionName = 'Выберите регион';
                    this.weekName = this.allWeeks[0];
                    this.weekBefore = this.allWeeks[1];
                    this.highlightCreditor = false;
                    this.highlightRegion = false;
                    this.highlightWeek = false;
                    this.highlightColumn = false;
                    this.showArr = [];
                },
                handlerSelect(data) {
                    this.openSelect === data
                        ? this.openSelect = ''
                        : this.openSelect = data;
                },
                handlerSearch(data) {
                    if (data === 'creditor') {
                        let curUrl = this.url + '&reportType=creditors&query=' + this.searchCreditor
                        this.getApiData(curUrl, 'searchArrCreditors', true);
                    }
                    if (data === 'region') {
                        let curUrl = this.url + '&reportType=regions&query=' + this.searchRegion
                        this.getApiData(curUrl, 'searchArrRegions', true);
                    }
                },
                handlerResetFilter() {
                    this.getApiData(this.reportUrl, 'tableData');
                    this.resetFilter();
                },
                getWindowWidth() {
                    return document.documentElement.clientWidth;
                },
                changeColumn(item, idx) {
                    this.columnName = item;
                    this.highlightColumn = true;
                    this.columnId = idx;
                    this.openSelect = '';
                },
                datePlusOneDay(weekBefore) {
                    if (!weekBefore) return '';

                    const curDate = weekBefore.replace(/(\d\d)\.(\d\d)\./g, '$2/$1/');
                    const curDateObj = new Date(curDate);
                    curDateObj.setDate(curDateObj.getDate() + 1);

                    return curDateObj.toLocaleDateString('ru-RU');
                }
            }
        }).mount(reportParent);
    }
});